module.exports = __webpack_public_path__ + "assets/img/23_128_big.c79921a0.jpg";